<div class="flex flex-row items-center text-[11px] text-[#8B96A2] m-3">
  <button (click)="showExitDialog()" class="hover:bg-[#E5E8EB] py-[2px] px-[4px] rounded">
    User Agreement Management
  </button>
  <mat-icon fontIcon="chevron_right"></mat-icon>
  <button (click)="agreementCreateEdit()" class="hover:bg-[#E5E8EB] py-[2px] px-[4px] rounded">
    {{add? 'New' : 'Edit'}} User Agreement
  </button>
  <mat-icon fontIcon="chevron_right"></mat-icon>
  <div class="text-black border-[#2663FF] border rounded w-fit py-[2px] px-[4px]">
    Preview
  </div>
</div>
<breadcrumb endText="Preview" />
<!-- TODO need to implement the exit dialog without having to duplicate it -->
@if (openExitDialog) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60">
    <div class="h-full w-full">
      <div class="cancelDialog">
        <p class="font-bold z-10">Sure you want to leave?</p>
        <p class="mt-3 z-10">Your changes are not saved automatically and will be discarded if you exit now. Make sure to save your changes before you exit.</p>
        <fa-icon class="mt-3 z-10" [icon]="faTriangleExclamation" size="5x"></fa-icon>
        <div class="h-[38px] mt-5 flex flex-row z-10">
          <full-button [marginRight]="true" (click)="closeExitDialog()" text="Cancel" />
          <outline-button (click)="agreementManagement()" text="Exit Now" />
        </div>
        <fa-icon class="backgroundExit" [icon]="faTriangleExclamation" size="10x"></fa-icon>
      </div>
    </div>
  </div>
}
<div class="m-5">
  <div class="flex items-end justify-between my-2">
    <p class="text-xl mb-1 flex-none font-medium">
      User Agreement Preview
    </p>
    <outline-button (click)="agreementCreateEdit()" text="Exit Preview" />
  </div>
  <hr />
  <div class="flex flex-col max-h-[85%] items-center m-auto mt-6 border rounded border-gray-300 p-2 w-[80%]">
    <p class="flex-none font-medium text-2xl text-center pt-5 lg:pt-10 pb-5 lg:pb-10">
      {{previewData.title}}
    </p>
    <div class="flex-1 overflow-y-auto mx-[30px] lg:mx-[45px] lg:mx-8">
      <div class="overflow-x-hidden justify-center pr-3">
        <p [innerHTML]="previewData.body">
        </p>
      </div>
    </div>
    <p class="text-exam pt-5 font-medium text-red-600">
      {{previewData.notice}}
    </p>
    <div class="flex justify-center py-5">
      <full-button text="Accept and Continue" />
    </div>
  </div>
</div>
